module.exports = __webpack_public_path__ + "static/media/arrow.551ad5be.png";